import { useFragment } from '@apollo/client';
import {
  Avatar,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Typography,
  useTheme,
} from '@mui/material';
import { useCallback } from 'react';
import { DTOOLS_AUTH_DETAILS_FRAGMENT } from 'src/graphql/entities/integrations/dtools/dtools.fragments';
import { DtoolsAuthDetail } from 'src/graphql/entities/integrations/dtools/dtools.types';
import { useRevokeDtoolsAuthentication } from 'src/graphql/entities/integrations/dtools/hooks/use-revoke-dtools-authentication';

export type DtoolsIntegrationProps = {
  id: number;
};

export const DtoolsAuthDetails = ({ id }: DtoolsIntegrationProps) => {
  const theme = useTheme();
  const { revokeConnection } = useRevokeDtoolsAuthentication();

  const { data, complete } = useFragment<DtoolsAuthDetail>({
    fragment: DTOOLS_AUTH_DETAILS_FRAGMENT,
    from: {
      __typename: 'DtoolsAuthDetails',
      id,
    },
  });

  const onRevokeHandler = useCallback(async () => {
    await revokeConnection(data.partnerId!);
  }, [data.partnerId, revokeConnection]);

  if (!complete) {
    return null;
  }

  return (
    <Card variant="outlined">
      <CardHeader
        avatar={<Avatar alt="d-tools-logo" src="/d-tools-logo.png" />}
        title="D-Tools Cloud"
        subheader="Connected"
        slotProps={{
          subheader: {
            color: theme.palette.success.main,
          },
        }}
      />
      <CardContent>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          API Key
        </Typography>
        <Typography variant="body1">{data.maskedApiKey}</Typography>
      </CardContent>
      <CardActions sx={{ m: theme.spacing() }}>
        <Button variant="outlined" onClick={onRevokeHandler} size="small" fullWidth color="error">
          Disconnect
        </Button>
      </CardActions>
    </Card>
  );
};
